const YN = (v) => (v === true ? "Yes" : v === false ? "No" : "—");
const fmt = (s) => (s ? new Date(s).toLocaleString() : "—");

// Read-only recap of what the client filled in on the public /book form.
export function WebsiteRequestBlock({ details }) {
  if (!details) return null;
  const rows = [
    ["Submitted", fmt(details.submitted_at)],
    ["Car requested", details.vehicle_label || "—"],
    ["Plate", details.vehicle_plate || "—"],
    ["Age", details.client_age || "—"],
    ["G / Class 6 licence", YN(details.has_license_class6)],
    ["Own insurance", YN(details.has_insurance)],
    ["Rental coverage on policy", YN(details.has_rental_coverage)],
    ["Insurance company", details.insurance_company || "—"],
    ["Credit card rental coverage", YN(details.has_cc_rental_coverage)],
  ];
  return (
    <div className="col-span-2 rounded-2xl border border-emerald-500/30 bg-emerald-500/[0.04] p-4" data-testid="website-request-block">
      <div className="label-mono text-emerald-300 mb-3">Website request — as submitted</div>
      <div className="grid grid-cols-2 gap-x-6 gap-y-2 text-sm">
        {rows.map(([k, v]) => (
          <div key={k} className="flex items-baseline justify-between gap-3 border-b border-border/40 pb-1.5">
            <span className="text-xs text-muted-foreground">{k}</span>
            <span className="text-right">{v}</span>
          </div>
        ))}
      </div>
      {details.customer_notes && (
        <div className="mt-3 text-sm">
          <div className="label-mono mb-1">Their message</div>
          <div className="text-muted-foreground whitespace-pre-wrap">{details.customer_notes}</div>
        </div>
      )}
    </div>
  );
}
